import * as zod from 'zod';

import { comboboxSchema } from '~/components/Combobox';
import {
  ResourceTypeSchema,
  RoleSchema,
  UserTypeSchema,
} from '~/modules/settings/api/lib/schemas';

// NOTE: max numbers are coming from COOP failed requests (any more than that will fail request)
export const userFormSchema = zod
  .object({
    firstName: zod.string().trim().min(1).max(50),
    lastName: zod.string().trim().min(1).max(50),
    jobTitle: zod.string().trim().min(1).max(200),
    email: zod.string().trim().min(1).max(70).email(),
    phone: zod.string().trim().max(64).optional(),
    isActive: zod.boolean().default(true),
    organization: zod.string().optional(),
    userType: UserTypeSchema.default('EXTERNAL').optional(),
    roleMap: zod
      .array(
        zod.object({
          role: RoleSchema,
          resources: zod.array(comboboxSchema),
          type: ResourceTypeSchema.optional(),
        }),
      )
      // TODO: remove optional once settings_internal_user_updates is removed
      .optional(),

    // TODO: remove internalPermissions and externalPermissions once settings_internal_user_updates is removed
    internalPermissions: zod
      .object({
        roles: zod.array(comboboxSchema).min(1),
        labelGroups: zod.array(comboboxSchema).min(1),
      })
      .optional(),
    externalPermissions: zod
      .array(
        zod.object({
          role: RoleSchema,
          labels: zod.array(comboboxSchema).min(1),
        }),
      )
      .optional(),
  })
  .superRefine((data, ctx) => {
    // Note: This check should not be needed, since the form will not render
    //  the organization field for an external user.
    if (data.userType === 'EXTERNAL' && data.organization) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        message: 'externalOrganizationNotAllowed',
        path: ['organization'],
      });
    } else if (data.userType !== 'EXTERNAL' && !data.organization) {
      ctx.addIssue({
        code: zod.ZodIssueCode.custom,
        message: 'internalOrganizationRequired',
        path: ['organization'],
      });
    }
  });

export type UserFormSchema = zod.infer<typeof userFormSchema>;
